import React, { useEffect, useState } from 'react'
import './App.css'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { MainPage } from './pages/main'
import { LoginPage } from './pages/login'
import ErrorBoundary from 'antd/es/alert/ErrorBoundary'
import { SignUpPage } from './pages/sign-up'
import { attachToStore } from './service/websocket'
import { TicTacToeLobby } from './games'
import store, { useStore } from './store/basic-store'
import { Modal, ModalFuncProps } from 'antd'
import { JsonObj, Transport, User } from './types'
import { TicTacToeGameBoard } from './games/tic-tac-toe/game-board'
import { MyGames } from './pages/my-games'
import { getMyGames } from './service/game.action'
import { ProfilePage } from './pages/profile'
import { GamesPage } from './pages/games'
import { GroupsPage } from './pages/groups'
import { GroupPage } from './pages/group'
import { DlistPage } from './pages/dlist/dlist.page'
import { DlistDetailsPage } from './pages/dlist/dlist-details.page'
import { SwingTradePage } from './pages/dlist/dlist-swing-trade'
import { WatchListPage } from './pages/dlist/dlist-watch-list.page'
import { TradewarsLobby } from './games/tradewars/tradewars-lobby.component'
import { TradewarsGame } from './games/tradewars/tradewars.game'
import { Adulting101Page } from './pages/adulting/adulting-101'
import { Adulting101HygienePage } from './pages/adulting/adulting-101-hygiene'
import { Adulting101TimeManagementPage } from './pages/adulting/adulting-101-time-management'
import { Adulting101CommunicationSkillsPage } from './pages/adulting/adulting-101-communication-skills'
import { Adulting101ResponsibilityPage } from './pages/adulting/adulting-101-responsibility'
import { Adulting101EmotionalIntelligencePage } from './pages/adulting/adulting-101-emotional-intelligence'
import { Adulting101ProblemSolvingPage } from './pages/adulting/adulting-101-problem-solving'
import { Adulting101FinancialLiteracyPage } from './pages/adulting/adulting-101-financial-literacy'
import { Adulting101HouseholdCarePage } from './pages/adulting/adulting-101-household-care'
import { Adulting101FriendsAndFamilyPage } from './pages/adulting/adulting-101-friends-and-family'
// import { Adulting101LikeLoveLustPage } from './pages/adulting/adulting-101-like-love-lust'
import { Adulting101SpiritualAwarenessPage } from './pages/adulting/adulting-101-spiritual-awareness'
import { Adulting101QuizPage } from './pages/adulting/adulting-101-quiz'

attachToStore()
const router = createBrowserRouter([
  {
    path: '/',
    element: <MainPage />,
  },
  {
    path: '/adulting-101',
    element: <Adulting101Page />,
  },
  {
    path: '/adulting-101/hygiene',
    element: <Adulting101HygienePage />,
  },
  {
    path: '/adulting-101/time-management',
    element: <Adulting101TimeManagementPage />,
  },
  {
    path: '/adulting-101/communication-skills',
    element: <Adulting101CommunicationSkillsPage />,
  },
  {
    path: '/adulting-101/responsibility',
    element: <Adulting101ResponsibilityPage />,
  },
  {
    path: '/adulting-101/emotional-intelligence',
    element: <Adulting101EmotionalIntelligencePage />,
  },
  {
    path: '/adulting-101/problem-solving',
    element: <Adulting101ProblemSolvingPage />,
  },
  {
    path: '/adulting-101/financial-literacy',
    element: <Adulting101FinancialLiteracyPage />,
  },
  {
    path: '/adulting-101/household-care',
    element: <Adulting101HouseholdCarePage />,
  },
  {
    path: '/adulting-101/friends-and-family',
    element: <Adulting101FriendsAndFamilyPage />,
  },
  // {
  //   path: '/adulting-101/like-love-lust',
  //   element: <Adulting101LikeLoveLustPage />,
  // },
  {
    path: '/adulting-101/spiritual-awareness',
    element: <Adulting101SpiritualAwarenessPage />,
  },
  {
    path: '/adulting-101/quiz',
    element: <Adulting101QuizPage />,
  },
  {
    path: '/dlist/dividend',
    element: <DlistPage />,
  },
  {
    path: '/dlist/stock/:ticker',
    element: <DlistDetailsPage />,
  },
  {
    path: '/dlist/swing-trade',
    element: <SwingTradePage />,
  },
  {
    path: '/dlist/watch-list',
    element: <WatchListPage />,
  },
  {
    path: '/dlist/swing-trade/stock/:ticker',
    element: <DlistDetailsPage />,
  },
  {
    path: '/games',
    element: <GamesPage />,
  },
  {
    path: '/groups',
    element: <GroupsPage />,
  },
  {
    path: 'groups/:id',
    element: <GroupPage />,
  },
  {
    path: 'games/tic-tac-toe',
    element: <TicTacToeLobby />,
  },
  {
    path: 'games/tic-tac-toe/game/:id',
    element: <TicTacToeGameBoard />,
  },
  {
    path: '/games/tradewars',
    element: <TradewarsLobby />,
  },
  {
    path: 'games/tradewars/game/:id',
    element: <TradewarsGame />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/my-games',
    element: <MyGames />,
  },
  {
    path: '/profile',
    element: <ProfilePage />,
  },
  {
    path: '/sign-up',
    element: <SignUpPage />,
  },
])

function App() {
  const myGames: { id: string }[] | null = useStore('my-games')
  const user = useStore<User>('user')

  useEffect(() => {
    if (user?.id && !myGames) {
      getMyGames()
    }
  }, [user, myGames])
  return (
    <ErrorBoundary>
      <ErrorMessage />
      <RouterProvider router={router}></RouterProvider>
    </ErrorBoundary>
  )
}

export function ErrorMessage() {
  const [modal, contextHolder] = Modal.useModal()
  const errorPayload = useStore<Transport>('error')
  const [open, setOpen] = useState(!!errorPayload)
  const [lastError, setLastError] = useState('')

  console.log('ErrorMessage errorPayload: ', errorPayload)
  const onOk = () => {
    store.set('error', null)
    setOpen(false)
  }
  useEffect(() => {
    if (errorPayload?.error && !open) {
      const { error } = errorPayload
      const errorCode = (error as JsonObj).errorCode
      const name = (error as JsonObj).name || 'Error'
      const message = (error as JsonObj).message || errorPayload.message || 'Bad Things happened'
      const config: ModalFuncProps = {
        title: 'Error',
        content: <div>{message}</div>,
        onOk,
      }
      if (lastError !== message) {
        setOpen(true)
        setLastError(message)
      } else {
        setOpen(false)
      }

      switch (errorCode) {
        case 'UNAUTHORIZED':
          config.title = name
          config.content = <div>{message}</div>
          config.onOk = () => {
            onOk()
            store.set('auth', null)
            localStorage.setItem('auth', '')
            // @ts-ignore
            window.location = '/'
          }
          break
        default:
      }

      modal.error(config)
    }
  }, [errorPayload])
  return <>{contextHolder}</>
}

export default App
